import { NO_COACH_SELECTED, NO_COACH_SELECTED_AD, NO_RESULTS } from "./constants";
import { IGetHeaderTextParams } from "./types";

export const getHeaderText = ({
  isCoachSelected,
  hasEvaluations,
  currentCoachName,
  isADSurveys
}: IGetHeaderTextParams
) => {
  let text = "";
  if (isCoachSelected) {
    text = hasEvaluations ? currentCoachName : NO_RESULTS;
  } else {
    text = isADSurveys ? NO_COACH_SELECTED_AD :NO_COACH_SELECTED;
  }
  return text;
};



// WEBPACK FOOTER //
// ./src/features/director/pages/SurveyDataCenter/utils/getHeaderText/getHeaderText.ts